import { Drawer } from '@app/components'
import { OnRampDrawerProps } from '@app/types'
import { WalletCard } from 'collections/account-registration/connect-wallet/wallet-card'
import React from 'react'

export const AddWalletDrawer: React.FC<OnRampDrawerProps> = ({ open, toggleOpen, refresh }) => {
  return (
    <>
      <Drawer title="Add New Wallet" placement="right" onClose={toggleOpen} open={open}>
        <WalletCard refresh={refresh} toggleOpen={toggleOpen} />
      </Drawer>
    </>
  )
}
